import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "@/components/pages/HomePage";
import HireWorkersPage from "@/components/pages/HireWorkersPage";
import RealEstatePage from "@/components/pages/RealEstatePage";
import MarketplacePage from "@/components/pages/MarketplacePage";
import AdminPanel from "@/components/AdminPanel";
import WorkerLogin from "@/components/WorkerLogin";
import WorkerDashboard from "@/components/WorkerDashboard";
import FloatingPostButton from "@/components/FloatingPostButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hire-workers" element={<HireWorkersPage />} />
          <Route path="/real-estate" element={<RealEstatePage />} />
          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/worker-login" element={<WorkerLogin />} />
          <Route path="/worker-dashboard" element={<WorkerDashboard />} />
        </Routes>
        <FloatingPostButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
